import { Color } from './types';

export interface PositionOccurrence {
  hash: string;
  mover: Color | null;
  gaveCheck: boolean;
}

export type RepetitionResult =
  | { kind: 'none' }
  | { kind: 'draw' }
  | { kind: 'perpetual-check-loss'; loser: Color };

export function classifyRepetition(
  history: readonly PositionOccurrence[],
  currentHash: string,
): RepetitionResult {
  const matches: number[] = [];
  for (let i = history.length - 1; i >= 0 && matches.length < 3; i--) {
    if (history[i].hash === currentHash) matches.push(i);
  }
  if (matches.length < 3) return { kind: 'none' };

  const cycleStart = matches[2];
  const cycleEnd = matches[0];
  const cycle = history.slice(cycleStart + 1, cycleEnd + 1);

  const perpetualCheckers: Color[] = [];
  for (const color of ['r', 'b'] as const) {
    const moves = cycle.filter(entry => entry.mover === color);
    if (moves.length > 0 && moves.every(entry => entry.gaveCheck)) {
      perpetualCheckers.push(color);
    }
  }

  if (perpetualCheckers.length === 1) {
    return { kind: 'perpetual-check-loss', loser: perpetualCheckers[0] };
  }
  return { kind: 'draw' };
}
